
// Libraries
var React = require('react');
var $ = require('jquery');

// Styles
require('./GoogleMap.scss');

class GoogleMapModule extends React.Component {

	// Generates unique UID to handle the div where the embedded map will be placed.
	uuidv4 = () => {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			let r = Math.random() * 16 | 0;
			let v = c === 'x' ? r : ((r & 0x3) | 0x8);
			return v.toString(16);
		});
	};

	constructor(props) {
		super(props);

		this.state = {
			targetId: ""
		};
	}

	componentDidMount() {
		window.addEventListener('load', _ => {

			this.setState({ targetId: this.uuidv4() });

			if (typeof window['google'] === 'undefined') {
				let googlemaps = window.location.protocol + "//maps.googleapis.com/maps/api/js?key=AIzaSyBSpMipTbKXyQTJrDDKHgPo-j5qPC5d4bM";
				let scriptTag = document.createElement('script');

				scriptTag.src = googlemaps;
				document.getElementsByTagName('body')[0].appendChild(scriptTag);

				let poll = 0;
				let timer = setInterval(() => {
					if (typeof window['google'] !== 'undefined') {
						clearInterval(timer);
						this.createMaps();
					} else if (poll > 1000) {
						clearInterval(timer);
						console.warn('Timed out waiting for google.');
					} else {
						poll += 1;
					}
				}, 50);
			} else {
				this.createMaps();
			}
		});
	}

	createMaps() {
		const maps = $('#' + this.state.targetId);

		for(let i = 0; i < maps.length; i++) {
			const $map = $(maps[i]);
			const lat = $map.data('lat');
			const lng = $map.data('lng');
			const latlng = new window['google'].maps.LatLng(lat, lng);

			const options = {
				zoom: 16,
				center: latlng,
				disableDefaultUI: true,
				scrollwheel: false
			};

			const googleMap = new window['google'].maps.Map($map.get(0), options);
		
			new window['google'].maps.Marker({
				position: latlng,
				map: googleMap,
				icon: this.props.data.baseUrl + '/static/media/spurs-logo-map-pin.png'
			});
		}
	};

	render() {
		return (
			<section className="GoogleMap">
				<div className="GoogleMap__container" id={this.state.targetId} data-lat={this.props.data.latitude} data-lng={this.props.data.longitude}></div>
			</section>
		)
	}
}

module.exports = GoogleMapModule;



// WEBPACK FOOTER //
// ./src/components/GoogleMap/GoogleMapModule.js